import { Translate } from '..';
import { ClientesSecurityDto } from '../../model/clientes';
import { UsuarioLoginInfoOut } from '../../model/seguridad';
import { Actions } from './reducers';
import { store } from './store';

/* devuelve un action */
export const get = (action: Actions, payload: any) => ({ type: action, payload });

/* Informa un cambio de usuario */
export const UserChanged = (user?: UsuarioLoginInfoOut) => store.dispatch(get(Actions.USER_CHANGED, user));

/* Informa un cambio de cliente */
export const ClienteChanged = (cliente?: ClientesSecurityDto) => store.dispatch(get(Actions.CLIENTE_CHANGED, cliente));

/* Informa un cambio de idioma */
export const LanguajeChanged = (lang: string) => {
  Translate.setLocale(lang);
  store.dispatch(get(Actions.LANGUAJE_CHANGED, lang))
};
